/* eslint-disable no-param-reassign */
import Bugsnag from '@bugsnag/js'
import debug from 'util/debug'
import { doFetchTicketEventGroups } from './doFetchTicketEventGroups'
import { selectTicketEventGroupsByConversationId } from '../selectors/selectTicketEventGroupsByConversationId'

export function doRecordErrorAndFetchTicketEventGroups(
  ticketId,
  eventGroups,
  options = {}
) {
  return async (dispatch, getState) => {
    debug(
      'Changesets component detected with no event groups, attempting automatic repair',
      {
        ticketId,
        eventGroups,
      }
    )

    let response = null
    let loadedEventGroups = null

    try {
      response = await dispatch(doFetchTicketEventGroups(ticketId, options))
      loadedEventGroups = selectTicketEventGroupsByConversationId(
        getState(),
        ticketId
      )

      debug('Changesets component data after automatic repair', {
        ticketId,
        eventGroups,
        loadedEventGroups,
        response,
      })

      if (loadedEventGroups.length === 0) {
        throw new Error('Event group empty after reload')
      }
    } catch (error) {
      debug('Unable to automatically repair event groups', {
        ticketId,
        eventGroups,
        loadedEventGroups,
        response,
      })

      // Network errors are transient - don't report to Bugsnag
      const isNetworkError =
        error.message?.includes('Failed to fetch') ||
        error.message?.includes('NetworkError') ||
        error.message?.includes('timeout') ||
        (error.name === 'TypeError' && error.message?.includes('fetch'))

      if (!isNetworkError) {
        Bugsnag.notify(
          new Error('Changesets component detected with no event groups'),
          event => {
            // eslint-disable-next-line no-param-reassign
            event.severity = 'warning'

            event.addMetadata('metaData', {
              ticketId,
              eventGroups,
              loadedEventGroups,
              response,
              originalError: {
                message: error.message,
                stack: error.stack,
                name: error.name,
              },
            })
          }
        )
      }
    }
  }
}
